import emojiMartData from '@emoji-mart/data'
import capitalize from 'lodash/capitalize'

import type { EmojiCategoryData, EmojiData, EmojiKey } from './types'

export function getEmojiCategories(
  categoryOrderIds: string[]
): EmojiCategoryData[] {
  const data: EmojiCategoryData[] = []
  categoryOrderIds.forEach((categoryId) => {
    const category = emojiMartData.categories.find(
      (category) => category.id === categoryId
    )
    if (category) {
      data.push({
        id: category.id,
        name: capitalize(category.id),
        emojis: category.emojis,
      })
    }
  })

  return data
}

export function getEmojiIndex() {
  const emojis = emojiMartData.emojis as Record<string, EmojiData>
  return emojis
}

export function getEmojiAliases() {
  const emojiAliases = emojiMartData.aliases as Record<string, string>
  return emojiAliases
}

export function getEmojiData(key: EmojiKey) {
  const emojis = emojiMartData.emojis as Record<string, EmojiData>
  return emojis[key]
}

export function getEmojiDefaultUnified(emoji: EmojiData) {
  // default value while we don't handle it
  return emoji.skins[0]?.unified.toUpperCase()
}

export function isEmojiKey(key: string): key is EmojiKey {
  const emojis = emojiMartData.emojis as Record<string, EmojiData>
  return key in emojis
}
